export class ContractorSearchRequest {

    _page; // number
    _term; // string

    constructor() {
        this._page = 1;
        this._term = '';
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                only_active: true,
                only_inactive: false,
                show_only_deleted: false,
            },
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/my-contractors/contractor/list/contractor-search/ContractorSearchRequest.js